import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MapPropertyListPipe } from './pipes/map-property-list.pipe';
import { InfiniteScrollDirective } from './directives/infinite-scroll.directive';

@NgModule({
  declarations: [
    InfiniteScrollDirective,
    MapPropertyListPipe,
  ],

  imports: [
    CommonModule,
  ],

  exports: [
    InfiniteScrollDirective,
    MapPropertyListPipe
  ],

  providers: [ ],
})

export class SharedModule { }





export interface IValueText {
  Value: any;
  Text: string;
}

// export interface IIcon {
//   iconLibrary: string;
//   iconName: string;
// }

